<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section>
      <div
        class="review-container review-main text-capitalize position-relative"
      >
        <lottie-animation
          ref="anim"
          :animationData="require('@/assets/animation.json')"
          class="animationCls"
          v-if="isAnimation"
        />
        <div class="row">
          <div class="col-md-12 p-0">
            <div>
              <div class="resturant-details plr15">
                <h4 class>{{ $t("Select Payment Method") }}</h4>
              </div>
              <div class="plr15 mt-4">
                <div class="payble-amount">
                  <span class="mb-1 d-inline-block">{{
                    $t("Payable Amount")
                  }}</span>
                  <h2 v-if="Object.keys(this.placeOrderData).length > 0">
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span
                    >{{
                      placeOrderData && placeOrderData?.calculation?.total
                        ? placeOrderData.calculation.total
                        : 0
                    }}
                  </h2>
                  <h2
                    v-else-if="Object.keys(this.chowmanPayOrderData).length > 0"
                  >
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span
                    >{{
                      chowmanPayOrderData && chowmanPayOrderData.total_amount
                        ? chowmanPayOrderData.total_amount
                        : 0
                    }}
                  </h2>
                  <h2
                    v-else-if="
                      Object.keys(this.chowmanPayGiftVoucher).length > 0
                    "
                  >
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span
                    >{{
                      chowmanPayGiftVoucher && chowmanPayGiftVoucher.amount
                        ? chowmanPayGiftVoucher.amount
                        : 0
                    }}
                  </h2>
                </div>
                <div class="mt-3">
                  <form
                    class="boxed payment-box"
                    v-if="isPayCodEnable || isPayOnlineEnable"
                  >
                    <div
                      class="d-block position-relative"
                      v-if="
                        isPayCodEnable &&
                        codCheckPayment &&
                        placeOrderData.order_time == ''
                      "
                    >
                      <input
                        type="radio"
                        id="cod"
                        name="payusing"
                        value="cod"
                        v-model="payusing"
                      />
                      <label for="cod">
                        <div class="card-cls">
                          <img src="@/assets/images/card1.svg" />
                        </div>
                        <span>{{ $t("Cash On Delivery") }}</span>
                      </label>
                    </div>
                    <div class="d-block position-relative">
                      <input
                        type="radio"
                        id="payonline1"
                        name="payusing"
                        value="razorpay"
                        v-model="payusing"
                      />
                      <label for="payonline1">
                        <div class="card-cls">
                          <img src="@/assets/images/card2.svg" />
                        </div>
                        <span>{{ $t("Pay Online") }}</span>
                      </label>
                    </div>
                    <div
                      class="d-block position-relative"
                      v-if="
                        mywalletAmount > 0 &&
                        Object.keys(this.chowmanPayGiftVoucher).length == 0
                      "
                    >
                      <input
                        type="radio"
                        id="payonline2"
                        name="payusing"
                        value="wallet"
                        v-model="payusing"
                      />
                      <label for="payonline2" class="pay-lable">
                        <div class="card-cls">
                          <img src="@/assets/images/icon_wallet.png" />
                        </div>
                        <div
                          class="d-flex align-items-center justify-content-between w-100"
                        >
                          <span>{{ $t("Pay via Wallet") }} </span>
                          <span class="wlt-amt"
                            ><span
                              v-html="$auth.setting.currency"
                              class="currency"
                            ></span>
                            {{ mywalletAmount }}</span
                          >
                        </div>
                      </label>
                    </div>
                  </form>
                  <div v-else class="order-offers rest-not-found">
                    <div class="text-center my-2" v-if="loading">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="plr15 delivery-address">
              <div class="full-btn green-btn">
                <b-button
                  variant="primary"
                  class="nxt-btn"
                  disabled
                  v-if="isDisabled"
                >
                  <b-spinner small type="grow"></b-spinner>
                  {{ $t("Loading") }}...
                </b-button>
                <button
                  v-else-if="
                    !isDisabled && Object.keys(this.placeOrderData).length > 0
                  "
                  @click="checkOrder"
                  :disabled="isDisabled"
                >
                  {{ isDisabled ? $t("Placing Order...") : $t("Place Order") }}
                </button>
                <button
                  v-else-if="
                    !isDisabled &&
                    Object.keys(this.chowmanPayOrderData).length > 0
                  "
                  @click="placeChowmanPayment"
                  :disabled="isDisabled"
                >
                  {{ isDisabled ? $t("Placing Order...") : $t("Place Order") }}
                </button>
                <button
                  v-else-if="
                    !isDisabled &&
                    Object.keys(this.chowmanPayGiftVoucher).length > 0
                  "
                  @click="chowmanGiftPayment()"
                  :disabled="isDisabled"
                >
                  {{ isDisabled ? $t("Placing Order...") : $t("Place Order") }}
                </button>
              </div>
            </div>
            <track-order
              v-if="isOrderSuccess"
              :orderId="placeOrderId"
              :iswallet="iswallet"
              :isChownmanPay="isChownmanPay"
              :chowmanPayTrans="chowmanPayTrans"
              :isGiftVoucher="isGiftVoucher"
            ></track-order>
            <fail-order v-if="isOrderfail"></fail-order>
          </div>
        </div>
      </div>
    </section>
    <!--Alert Modal start-->
    <AlertModal
      v-if="isAlert"
      :DisplayAlertData="AlertData"
      v-on:modalClose="onModalCloseFun"
    ></AlertModal>
    <!--Alert Modal End-->
    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NavBar from "../components/NavBar.vue";
import TrackOrder from "../components/TrackOrder.vue";
import FailOrder from "../components/FailOrder.vue";
import AlertModal from "../components/AlertModal.vue";
import Footer from "../components/Footer.vue";
import { Razorpay } from "razorpay-checkout";
import Wallet from "../apis/wallet";
import LottieAnimation from "lottie-web-vue";
import config from '../config/index';

export default {
  components: {
    NavBar,
    TrackOrder,
    FailOrder,
    AlertModal,
    Footer,
    LottieAnimation,
  },
  data() {
    return {
      config:config,
      isOrderfail: false, //Fail order popup
      isOrderSuccess: false, //Success order popup
      payusing: "", //Customer's selected payment gateway
      payment_gateway_list: [], //Admin payment gateway list
      restaurant_payment_option: "", //Admin payment setting
      // payment_option:"", //Store payment setting
      restaurantId: 0, //StoreId
      restaurantData: [], //Store data
      isPayCodEnable: false, //Check cod payment
      isPayOnlineEnable: false, //Check online payment
      is_cod_enable: false, //Check customer cod option
      placeOrderData: {}, //Place order data
      placeOrderId: 0, //Place orderid, it get used when need to redirect to track screen
      isDisabled: false, //Used to enable/disable place order button, also for loading
      loading: true,
      isAlert: false,
      AlertData: {},
      iswallet: 0,
      walletamount: false,
      isdisplayOprions: false,
      codCheckPayment: true,
      onlineCheckPayment: true,
      priceChangeProducts: [],
      priceChangeProductscustomisation: [],
      mywalletAmount: 0,
      isChownmanPay: false,
      chowmanPayTrans: {},
      isGiftVoucher: false,
      isAnimation: false,
    };
  },
  computed: {
    ...mapGetters("order", [
      "place_order_data",
      "isPickupDelivery",
      "chowmanPayOrderData",
      "chowmanPayGiftVoucher",
    ]), //To get current order data to place
    ...mapGetters("address", ["primaryAddress"]), //To Get Primary address
    ...mapGetters("product", ["cart"]), //To cart items to check
  },
  mounted() {
    //Check customer login
    if (this.$auth.user) {
      this.is_cod_enable = this.$auth.user.is_cod_enable ? true : false;
      this.getWalltet();
    } else {
      this.$router.push({
        name: "Home",
      });
      // this.$router.push({
      //   name: this.isPickupDelivery == "2" ? "reservation" : "Home",
      // });
      return false;
    }

    //Get placing order data
    this.placeOrderData = this.place_order_data;
    if (
      this.placeOrderData == undefined ||
      this.placeOrderData == null ||
      !this.placeOrderData?.restaurant?.id
    ) {
      //this.$router.push({name:'Home'});
      //return false;
    } else {
      if (this.placeOrderData) {
        // if (this.placeOrderData?.restaurant?.id > 0) {
          this.restaurantId = this.placeOrderData?.restaurant?.id;
        // }
      }
    }

    if (this.placeOrderData && this.placeOrderData?.calculation &&  this.mywalletAmount > this.placeOrderData?.calculation?.total) {
      this.isdisplayOprions = false;
      this.walletamount = false;
    } else if (
      this.placeOrderData && this.placeOrderData?.calculation && this.mywalletAmount > this.placeOrderData.calculation.total
    ) {
      this.isdisplayOprions = true;
    }
    //Web pay order status
    let routeQry = this.$route.query;
    if (routeQry.success) {
      this.placeOrderId = routeQry.success;
      //window.$(this.$refs.PlaceOrderModal).modal();
      this.isOrderSuccess = true;
    } else if (routeQry.fail) {
      this.isOrderfail = true;
    }
    setTimeout(() => {
      //Get admin setting
      if (this.$auth.setting) {
        if (
          this.$auth.setting &&
          this.$auth.setting.restaurant_payment_option == "Both"
        ) {
          this.restaurant_payment_option =
            this.$auth.setting.restaurant_payment_option;
        }
      }
      if (Object.keys(this.placeOrderData).length > 0) {
        this.getRestaurantInfo();
        this.checked();
      } else {
        this.handlePaymentOptions();
      }
    }, 1000);
  },

  methods: {
    ...mapActions("restaurant", [
      "getRestaurantDetails",
      "getVendorOnOffStatus",
      "checkVendorRadius",
      "checkVendorMenuWithPrice",
    ]), //To get restaurant details
    ...mapActions("order", [
      "placeOrder",
      "postPaymentMethod",
      "getOrderPaymentStatus",
      "chowmanPaymentCreateData",
    ]), //To place an order
    ...mapActions("promocode", ["giftVoucherSelectData"]), //To place an order

    checked() {
      if ($("#wallt").is(":checked")) {
        if (this.mywalletAmount >= this.placeOrderData.calculation.total) {
          this.codCheckPayment = false;
          this.onlineCheckPayment = false;
          this.loading = false;
        } else {
          this.codCheckPayment = true;
          this.onlineCheckPayment = true;
          this.loading = false;
        }
      } else {
        this.codCheckPayment = true;
        this.onlineCheckPayment = true;
        this.loading = false;
      }
    },

    paymentOption() {
      if (this.isdisplayOprions) {
        this.isdisplayOprions = false;
      } else {
        this.isdisplayOprions = true;
      }
    },

    //Get restaurant details
    getRestaurantInfo() {
      if (this.restaurantId > 0) {
        this.getRestaurantDetails({

          vendor_id: this.$auth.getVendorId(),
          restaurant_id: this.restaurantId,
          is_langauge: this.$store.state.lang.locale,

        }).then((data) => {
          if (data.code == 200) {
            this.restaurantData = data.Result;
            // this.payment_option = this.$auth?.setting?.restaurant_payment_option;
            this.handlePaymentOptions();
          } else {
            alert(this.$t("Store not found"));
          }
        });
      } else {
        alert(this.$t("Store not found"));
      }
    },

    //Check enable/disable payment options
    handlePaymentOptions() {
      //Check master settings, As per store/outlet/restaurant choice

      if (
        this.restaurant_payment_option == "Restaurant Select Payment Option"
      ) {
        if (this.restaurant_payment_option == "Both") {
          this.isPayCodEnable = this.is_cod_enable ? true : false;
          this.isPayOnlineEnable = true;
        } else if (this.payment_option == "PAY ONLINE") {
          this.isPayCodEnable = false;
          this.isPayOnlineEnable = true;
        } else if (this.payment_option == "COD") {
          this.isPayCodEnable = this.is_cod_enable ? true : false;
          this.isPayOnlineEnable = false;
        }
        this.loading = false;
      } else {
        //Check master settings, As per admin choice
        if (this.restaurant_payment_option == "Both") {
          this.isPayCodEnable = this.is_cod_enable ? true : false;
          this.isPayOnlineEnable = true;
        } else if (this.restaurant_payment_option == "PAY ONLINE") {
          this.isPayCodEnable = false;
          this.isPayOnlineEnable = true;
        } else if (this.restaurant_payment_option == "COD") {
          this.isPayCodEnable = this.is_cod_enable ? true : false;
          this.isPayOnlineEnable = false;
        }
      }

      //Temp Only cash on delivery

      // this.isPayCodEnable = true;
      // this.isPayOnlineEnable = false;

      if (
        this.$auth.user &&
        this.$auth.user.cod_limit_validation == "0" &&
        this.placeOrderData &&  this.placeOrderData.calculation && 
        parseFloat(this.placeOrderData.calculation.total) >
          parseFloat(this.$auth.setting.minimum_no_cod_order_amount)
      ) {
        this.isPayCodEnable = false;
      }
    },

    onModalCloseFun(value) {
      if (value == "ok") {
        if (this.priceChangeProducts.length > 0) {
          this.priceChangeProducts.forEach((product) => {
            this.$store.commit("product/updateCart", product);
          });
        }
        if (this.priceChangeProductscustomisation.length > 0) {
          this.priceChangeProductscustomisation.forEach((product) => {
            this.$store.commit("product/updateCuatomizeCart", product);
          });
        }
        this.$router.push({name: "Home"}).catch(() => {});
        // this.$router
        //   .push({
        //     name: "vendor",
        //     params: {
        //       delivery_type:
        //         this.isPickupDelivery == "1"
        //           ? "delivery"
        //           : this.isPickupDelivery == "0"
        //           ? "takeaway"
        //           : this.isPickupDelivery == "2"
        //           ? "reservation"
        //           : "",
        //       restaurant_name: this.restaurantData.slug,
        //     },
        //   })
        //   .catch(() => {});
      }
      this.isAlert = false;
    },

    //Check order, update payment method and type to place order
    checkOrder() {
      if (this.payusing != "") {
        if (this.payusing == "cod") {
          this.placeOrderData.payment = {
            cod_amount: this.placeOrderData.calculation.total ?? 0,
            wallet_amount: 0,
            onine_amount: 0,
            payment_type: 1,
          };
        } else if (this.payusing == "wallet") {
          if (
            parseFloat(this.mywalletAmount) >=
            parseFloat(this.placeOrderData.calculation.total)
          ) {
            this.placeOrderData.payment = {
              cod_amount: 0,
              wallet_amount: this.placeOrderData.calculation.total,
              onine_amount: 0,
              payment_type: 2,
            };
          } else {
            this.placeOrderData.payment = {
              cod_amount: 0,
              wallet_amount: this.mywalletAmount ?? 0,
              onine_amount: parseFloat(
                this.placeOrderData.calculation.total - this.mywalletAmount
              ).toFixed(2),
              payment_type: 2 ,
            };
          }
        } else {
          this.placeOrderData.payment = {
            cod_amount: 0,
            wallet_amount: 0,
            onine_amount: this.placeOrderData.calculation.total ?? 0,
            payment_type: 3,
          };
        }
        this.orderRequest();
      } else {
        this.AlertData = {
          displayMessage: this.$t("Please select any payment option to pay"),
          isSetClass: "paymnt-modal-cls",
        };
        this.isAlert = true;
        window.$(this.$refs.AlertModal).modal();
      }
    },

    //Place order and redirect if payment is web payment
    orderRequest() {
      this.isDisabled = true;
      this.getRestaurantOnOffStatus();
    },

    getRestaurantOnOffStatus() {
      let date = "";
      let time = "";
      let vm = this;
      if (
        this.placeOrderData.order_time &&
        this.placeOrderData.order_time != ""
      ) {
        let datetime = this.placeOrderData.order_time.split(" ");
        date = datetime[0];
        time = datetime[1];
      }
      let data = {
        is_langauge: this.$store.state.lang.locale,
        delivery_type_time_slots: this.isPickupDelivery, //this.placeOrderData.delivery_type,
        starttime: time,
        restaurant_id: this.restaurantId,
        vendor_id: this.placeOrderData.vendor_id,
        date: date,
      };
      // this.getVendorOnOffStatus(data)
      //   .then((data) => {
      //     if (data.code == 200) {
      //       if (data.Result.status == "1" || data.Result.status == 1) {
      //         if (this.isPickupDelivery == 1 || this.isPickupDelivery == -1) {
                this.checkRestaurantRadius();
        //       } else {
        //         // this.checkRestaurantMenuWithPrice();
        //       }
        //     } else {
        //       alert(
        //         this.$t(
        //           "Restaurant is currently off, Please try after some time"
        //         )
        //       );
        //       this.isDisabled = false;
        //     }
        //   } else {
        //     alert(data.msg);
        //     this.isDisabled = false;
        //   }
        // })
        // .catch(function () {
        //   alert(vm.$t("Something went wrong, Please try again"));
        //   vm.isDisabled = false;
        // });
    },

    checkRestaurantRadius() {
      let vm = this;
      let data = {
        is_langauge: this.$store.state.lang.locale,
        latitude:
          this.primaryAddress.latitude && this.primaryAddress.latitude == ""
            ? this.primaryAddress.latitude
            : parseFloat(localStorage.getItem("latitude")),
        longitude:
          this.primaryAddress.longitude && this.primaryAddress.longitude == ""
            ? this.primaryAddress.longitude
            : parseFloat(localStorage.getItem("longitude")),
        restaurant_id: this.restaurantId,
        vendor_id: this.placeOrderData.vendor_id,
      };
      this.checkVendorRadius(data)
        .then((data) => {
          if (data.code == 200) {
              this.placeNewOrder();
            // this.checkRestaurantMenuWithPrice();
          } else {
            this.$swal(
              "Chowman",
              "<span>Oops! We do not deliver at your selected location.</span> <br>Click below to change address"
            );
            this.isDisabled = false;
          }
        })
        .catch(function () {
          vm.$swal("Chowman", "Something went wrong, Please try again");
          vm.isDisabled = false;
        });
    },
    placeNewOrder() {
      let vm = this;
      this.placeOrder(this.placeOrderData)
        .then((data) => {
          if (data.code == 200) {
            if (this.payusing == "razorpay") {
              this.placeOrderId = data?.Result?.order_id;
              this.placeOrderData.transaction_id = data?.Result?.transection_id;
              this.payOnline();
            } else if (this.payusing == "wallet") {
              if (
                parseFloat(this.mywalletAmount) >=
                parseFloat(this.placeOrderData.calculation.total)
              ) {
                this.paymentOrderStatus();
                if (data?.Result) {
                  if (data?.Result?.order_id && data?.Result?.order_id > 0) {
                    this.placeOrderId = data?.Result?.order_id;
                    this.isOrderSuccess = true;
                  }
                }
                this.isOrderSuccess = true;
                window.$(this.$refs.PlaceOrderModal).modal();
              } else {
                this.placeOrderId = data?.Result?.order_id;
                this.placeOrderData.transaction_id = data?.Result?.transection_id;
                this.payOnline();
                // this.placeOrderData.transaction_id
              }
            } else {
              
              this.paymentOrderStatus();
              if (data.Result) {
                if (data.Result && data.Result.order_id > 0) {
                  this.placeOrderId = data.Result.order_id;
                  this.isOrderSuccess = true;
                }
              }
              this.isOrderSuccess = true;
              window.$(this.$refs.PlaceOrderModal).modal();
            }
          } else if (data.code == 101) {
            this.AlertData = {
              displayMessage: this.$t(data.msg),
              isSetClass: "placeorder-modal-cls",
            };
            this.isAlert = true;
            this.isDisabled = false;
            window.$(this.$refs.AlertModal).modal();
          } else {
            this.isOrderfail = true;
          }
          this.isDisabled = false;
        })
        .catch(function () {
          vm.isDisabled = false;
          alert(vm.$t("Something went wrong, Please try again44"));
        });
    },
    payOnline() {
      let transactionID = "";
      let newRemAmout = 0;
      let notes = {};
      if (Object.keys(this.chowmanPayOrderData).length > 0) {
        newRemAmout = this.chowmanPayOrderData.online_paid_amount;
        transactionID = this.chowmanPayOrderData.transaction_id;
        notes = {
          pay_id: this.chowmanPayOrderData.order_id,
          type: "chowman_pay",
          order_id: this.placeOrderId,
        };
      } else if (Object.keys(this.chowmanPayGiftVoucher).length > 0) {
        newRemAmout = this.chowmanPayGiftVoucher.online_paid_amount;
        transactionID = this.chowmanPayGiftVoucher.transaction_id;
        notes = {
          pay_id: this.chowmanPayGiftVoucher.order_id,
          type: "gift_voucher",
          order_id: this.placeOrderId,
        };
      } else {
        newRemAmout = this.placeOrderData.calculation.total;
        if (this.payusing == "wallet") {
          newRemAmout = parseFloat(
            this.placeOrderData.calculation.total -
              this.mywalletAmount
          ).toFixed(2);
        }
        transactionID = this.placeOrderData.transaction_id;
        notes = {
          pay_id: this.placeOrderId, //transactionID,
          type: "Chowman Place Order",
          order_id: this.placeOrderId,
        };
      }
      this.isDisabled = true;
      let vm = this;
      var options = {
        key: config.razor_pay_key, 
        // key: this.$auth.setting.key_id, // Enter the Key ID generated from the Dashboard
        amount: newRemAmout * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: "chowmanweb",
        description: "Chowmanweb Transaction",
        image: this.$auth.getAppLogo(),
        order_id: transactionID, //this.placeOrderId, //transactionID, // this.placeOrderId, This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        handler: (response) => this.onPaymentSuccess(response),
        prefill: {
          name: this.$auth.user.user_name,
          email: this.$auth.user.user_email,
          contact: this.$auth.user.mobile_number,
        },
        notes: notes,
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            vm.isDisabled = false;
          },
        },
      };
      let rzp = new Razorpay(options);
      rzp.on("payment.failed", (errResponse) =>
        this.onPaymentFailure(errResponse)
      );
      rzp.open();
    },

    onPaymentSuccess(response) {
      if (Object.keys(this.chowmanPayOrderData).length > 0) {
        this.chowmanPayOrderData.transaction_id = response.razorpay_payment_id;
        this.placeOrderId = this.chowmanPayOrderData.order_id;

        this.isAnimation = true;
        this.$swal({
          icon: "success",
          showCloseButton: false,
          showConfirmButton: true,
          html:
            '<span class="text-black currency">Hooray, You have completed your payment of ' +
            this.$auth.setting.currency +
            this.chowmanPayOrderData.payFinalAmount +
            "<span> and earned cashback of " +
            this.$auth.setting.currency +
            " " +
            this.chowmanPayOrderData.cashback +
            "</span>",
        }).then((result) => {
          this.$router.push({ name: "chowman-pay-history" });
        });
        //window.$(this.$refs.PlaceOrderModal).modal();
      } else if (Object.keys(this.chowmanPayGiftVoucher).length > 0) {
        //this.isOrderSuccess = true;
        //this.isChownmanPay = true;
        let strhtml = "GIFT VOUCHER SENT SUCCESSFULLY";
        this.isAnimation = true;
        this.$swal({
          icon: "success",
          showCloseButton: false,
          showConfirmButton: true,
          html: strhtml,
        }).then((result) => {
          this.$router.push({ name: "gift-voucher-history" });
        });
        //window.$(this.$refs.PlaceOrderModal).modal();
      } else {
        this.placeOrderData.transaction_id = response.razorpay_payment_id;
        this.paymentOrderStatus();
      }
    },

    onPaymentFailure(response) {
      if (Object.keys(this.chowmanPayOrderData).length > 0) {
        // this.chowmanPayOrderData.transaction_id = response.razorpay_payment_id;
        // this.placeOrderId  = this.chowmanPayOrderData.order_id;
        // this.isOrderfail = true;
        // this.isChownmanPay = true;
        this.$swal({
          showCloseButton: false,
          showConfirmButton: true,
          html: '<span class="text-black currency">Your payment has been fail.</span>',
        }).then((result) => {
          this.$router.push({ name: "chowman-pay-history" });
        });
      } else if (Object.keys(this.chowmanPayGiftVoucher).length > 0) {
        // this.chowmanPayGiftVoucher.transaction_id = response.razorpay_payment_id;
        // this.placeOrderId  = this.chowmanPayGiftVoucher.order_id;
        // this.isOrderfail = true;
        // this.isChownmanPay = true;
        this.$swal({
          showCloseButton: false,
          showConfirmButton: true,
          html: '<span class="text-black currency">Your payment has been fail.</span>',
        }).then((result) => {
          this.$router.push({ name: "gift-voucher-history" });
        });
      } else {
        this.placeOrderData.transaction_id = response.razorpay_payment_id;
        this.paymentOrderStatus();
      }
    },

    paymentOrderStatus() {
      this.isDisabled = true;
      this.getOrderPaymentStatus({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        orderid: this.placeOrderId,
      }).then((response) => {
        this.isDisabled = false;
        if (response.code == 200) {
          if (response.status == "Placed") {
            this.isOrderSuccess = true;
            window.$(this.$refs.PlaceOrderModal).modal();
          }
        }
      });
    },

    getWalltet() {
      Wallet.getUserWalletAmount().then((response) => {
        if (response.data.code == 200) {
          this.mywalletAmount = response.data.wallet_amount.toFixed(2);
        }
      });
    },

    /*****ChowmanPay Payment***** */
    placeChowmanPayment() {
      let isWalletAmount = 0;
      if (this.payusing == "wallet") {
        isWalletAmount = 1;
      }
      if (this.payusing != "") {
        let data = {
          user_id: this.$auth.user.user_id,
          restaurant_id: this.chowmanPayOrderData.restaurant_id,
          amount: this.chowmanPayOrderData.amount,
          promocode_amount: this.chowmanPayOrderData.promocode_amount,
          promo_code: this.chowmanPayOrderData.promo_code,
          cashback_price: this.chowmanPayOrderData.cashback_price,
          wallet_amount: isWalletAmount,
          vendor_id: this.$auth.getVendorId(),
          device_type: "Web",
          is_langauge: this.$store.state.lang.locale,
          promo_code_id:this.chowmanPayOrderData.promo_code_id
        };
        this.chowmanPaymentCreateData(data).then((response) => {
          if (response.code == 200) {
            if (response.Result.payment_status == "Completed") {
              this.placeOrderId = response.Result.id;
              // this.isOrderSuccess = true;
              this.isChownmanPay = true;
              // this.chowmanPayTrans = {
              //   'txid':response.Result.unique_code,
              //   'final_amount':response.Result.final_amount,
              //   'cashback':response.Result.default_cashback+response.Result.cashback_price
              // };
              //window.$(this.$refs.PlaceOrderModal).modal();
              let cashback =
                response.Result.default_cashback +
                response.Result.cashback_price;
              let strhtml =
                '<span class="text-black currency">Hooray, You have completed your payment of ' +
                this.$auth.setting.currency +
                response.Result.final_amount +
                "</span>.";
              if (cashback > 0) {
                strhtml =
                  '<span class="text-black currency">Hooray, You have completed your payment of ' +
                  this.$auth.setting.currency +
                  response.Result.final_amount +
                  '<span v-if="cashback > 0"> and earned cashback of ' +
                  cashback +
                  "</span> </span>.";
              }
              this.isAnimation = true;
              this.$swal({
                icon: "success",
                showCloseButton: false,
                showConfirmButton: true,
                html: strhtml,
              }).then((result) => {
                this.$router.push({ name: "chowman-pay-history" });
              });
            } else if (response.Result.payment_status == "Pending") {
              this.chowmanPayOrderData.order_id = response.Result.id;
              this.chowmanPayOrderData.online_paid_amount =
                response.Result.online_paid_amount;
              this.chowmanPayOrderData.transaction_id =
                response.Result.order_id;
              this.chowmanPayOrderData.payFinalAmount =
                response.Result.final_amount;
              this.chowmanPayOrderData.cashback =
                response.Result.default_cashback +
                response.Result.cashback_price;
              this.payOnline();
            }
          }
        });
      } else {
        this.AlertData = {
          displayMessage: this.$t("Please select any payment option to pay"),
          isSetClass: "paymnt-modal-cls",
        };
        this.isAlert = true;
        window.$(this.$refs.AlertModal).modal();
      }
    },

    chowmanGiftPayment() {
      let isWalletAmount = 0;
      if (this.payusing == "wallet") {
        isWalletAmount = 1;
      }
      if (this.payusing != "") {
        let data = {
          name: this.chowmanPayGiftVoucher.name,
          email: this.chowmanPayGiftVoucher.email,
          custom_text: this.chowmanPayGiftVoucher.custom_text,
          amount: this.chowmanPayGiftVoucher.amount,
          gift_voucher_id: this.chowmanPayGiftVoucher.gift_voucher_id,
          wallet_amount: isWalletAmount,
          device_type: "Web",
          from_name: this.chowmanPayGiftVoucher.from_name,
        };
        this.giftVoucherSelectData(data).then((response) => {
          if (response.code == 200) {
            if (response.Result.payment_status == "completed") {
              this.placeOrderId = response.Result.id;
              // this.isOrderSuccess = true;
              // this.isChownmanPay = true;
              // this.isGiftVoucher = true;
              // this.chowmanPayTrans = {
              //   'txid':response.Result.code,
              //   'final_amount':response.Result.amount,
              // };
              //window.$(this.$refs.PlaceOrderModal).modal();
              let strhtml = "GIFT VOUCHER SENT SUCCESSFULLY";
              this.isAnimation = true;
              this.$swal({
                icon: "success",
                showCloseButton: false,
                showConfirmButton: true,
                html: strhtml,
              }).then((result) => {
                this.$router.push({ name: "gift-voucher-history" });
              });
            } else if (response.Result.payment_status == "pending") {
              this.chowmanPayGiftVoucher.order_id = response.Result.id;
              this.chowmanPayGiftVoucher.online_paid_amount =
                response.Result.online_amount;
              this.chowmanPayGiftVoucher.transaction_id =
                response.Result.transaction_id;
              this.chowmanPayTrans = {
                txid: response.Result.code,
                final_amount: response.Result.amount,
              };
              this.isGiftVoucher = true;
              this.payOnline();
            }
          } else {
            this.$swal("Chowman", response.msg);
          }
        });
      } else {
        this.AlertData = {
          displayMessage: this.$t("Please select any payment option to pay"),
          isSetClass: "paymnt-modal-cls",
        };
        this.isAlert = true;
        window.$(this.$refs.AlertModal).modal();
      }
    },
  },
};
</script>
<style scoped>
span.wlt-amt {
  color: red;
  margin-left: 236px;
}
.full-btn button,
.full-btn button:hover {
  background: #27ae60;
  border: none;
}
button.btn.btn-primary.disabled,
.prcc-cls-blr,
.prcc-cls,
.prcc-cls:hover,
.prcc-cls-blr:hover {
  background: #27ae60;
  border: none;
}
.delivery-address {
  border-top: 0 !important;
}
</style>